import { defaultFilterItem } from '../../components/AssignFlow/components/FilterItems/FilterItem';
import { TTaskDefaultFilters } from './searchForProjectDialog.types';

export const defaultFilters: TTaskDefaultFilters = {
  Customer: defaultFilterItem,
  LegalEntityProject: defaultFilterItem,
  ProjectDepartment: defaultFilterItem,
  ProjectManager: defaultFilterItem,
  ProjectType: defaultFilterItem,
};
